<template>
  <div class="tongyongdl">
    <div class="tongyongcard">
      <img src="../../../../assets/images/tiyancard.png" />
      <p
        style="
          color: #525b7a;
          line-height: 25px;
          font-weight: bold;
          letter-spacing: 1px;
          font-size: 15px;
        "
      >
        可以模拟交易体验软件的各种功能，体验期为一个月。
      </p>
      <p
        style="
          color: #525b7a;
          line-height: 25px;
          font-weight: bold;
          letter-spacing: 1px;
          font-size: 15px;
        "
      >
        软件凭体验账号登录使用。软件的登录界面，有注册体验账号的入口。
      </p>
    </div>
    <div class="tongyongbody">
      <div class="tongyongbodydl">
        <div class="tongyongdllf">
          <h4
            style="
              color: #1e5c88;
              line-height: 50px;
              height: 50px;
              padding-top: 30px;
              letter-spacing: 1px;
            "
          >
            使用应满足的条件
          </h4>
          <ResTxt class="waflls" id="1f6737aa80f5e" /><br>
          <ResTxt class="waflls" style="padding-left: 1.6em; text-indent: -1.6em;width: 370px;" id="f24df2283e542" /><br>
          <ResTxt class="waflls" id="e9b1ae5e2056a" /><br>
          <ResTxt class="waflls" id="8923dd3f3b9aa" /><br>
          <!-- <p class="waflls">1、X86架构的4线程CPU/8G内存（RAM），或更高配置；</p>
          <p class="waflls">2、硬盘空间要求：操作系统盘与软件安装盘的剩余可用空<br><span style="margin-left:26px">间分别都>20G（或硬盘总容量的20%）；</span></p>
          <p class="waflls">3、windows7、windows10等64位操作系统；</p>
          <p class="waflls">4、建议使用电信、联通宽带，其它宽带会有卡顿的问题。</p> -->
        </div>
        <div class="tongyongdlrg">
          <div class="dlbutton">
            <div
              style="
                background: #364064;
                border-radius: 0.5em;
                height: 45px;
                width: 140px;
                color: white;
                font-size: 18px;
                line-height: 45px;
                text-align: center;
                float: right;
                margin-right: 40px;
                cursor: pointer;
              "
              @click="liantong"
            >
              <img
                src="../../../../assets/images/xiazai.png"
                style="padding-right: 5px"
              />联通下载
            </div>
            <div
              style="
                background: #c4954d;
                border-radius: 0.5em;
                height: 45px;
                width: 140px;
                color: white;
                font-size: 18px;
                line-height: 45px;
                text-align: center;
                float: right;
                margin-right: 60px;
                cursor: pointer;
              "
              @click="dianxin"
            >
              <img
                src="../../../../assets/images/xiazai.png"
                style="padding-right: 5px"
              />电信下载
            </div>
          </div>
          <div
            style="
              font-size: 12px;
              height: 14px;
              line-height: 14px;

              color: #9b9b9c;
              letter-spacing: 0.5px;
            "
          >
            {{ tybanben }}
          </div>
          <div
            style="
              width: 330px;
              font-size: 12px;
              letter-spacing: 1px;
              padding: 5px 5px 0 5px;
              background: rgba(227, 233, 243, 0.7);
              position: absolute;
              bottom: 0;
              left: 0px;
            "
          >
            <img
              src="../../../../assets/images/care.png"
              style="vertical-align: top; margin-right: 2px"
            />
            <span style="color: #727983"
              >请在文华官网下载正版文华软件，文华官网下载不会</span
            >
            <br />
            <span style="padding-left: 18px; line-height: 24px; color: #727983"
              >以任何形式向你索要电话号码，请注意谨防上当。</span
            >
          </div>
        </div>
      </div>
      <div style="margin-left: 40px;margin-top:5px">
        <h4
          style="
            color: #1e5c88;
            line-height: 50px;
            height: 50px;
            padding-top: 30px;
            letter-spacing: 1px;
          "
        >
          注册体验账号
        </h4>
        <ResTxt
          style="
            text-indent: 2em;
            margin-right: 20px;
            letter-spacing: 1px;
            font-size: 15px;
            height: auto;
          "
          class="h4p"
          id="6de10b5855fe5"
        />
        <!-- <p
          class="h4p"
          style="
            text-indent: 2em;
            margin-right: 20px;
            letter-spacing: 1px;
            font-size: 15px;
          "
        >
          体验账号及密码在注册成功后将通过短信形式发送至你注册时预留的手机号。
        </p> -->
        <div style="margin-top: 25px; margin-left: 220px; margin-bottom: 30px">
          <img src="https://wh-api.wenhua.com.cn/api/WhBanner/GetWhBannerUrl?id=91" />
        </div>
      </div>
    </div>
    <pingjia></pingjia>
  </div>
</template>

<script>
import pingjia from "./pingjia.vue";
import ResTxt from '@/ResData/ResTxt'
import { jsonp } from "vue-jsonp";
export default {
  data() {
    return {
      tybanben: "",
      tydata: "",
    };
  },
  components: {
    pingjia,
    ResTxt
  },
  methods: {
    dianxin() {
      if (this.tydata.split("|")[0] == "") {
        alert("下载信息加载中，请稍后再试");
      } else {
        window.location.href =
          "//ftpc.wenhua.com.cn/files/wh7sim_setup_" +
          this.tydata.split("|")[0] +
          ".exe";
      }
    },
    liantong() {
      if (this.tydata.split("|")[0] == "") {
        alert("下载信息加载中，请稍后再试");
      } else {
        window.location.href =
          "//ftpc1.wenhua.com.cn/files/wh7sim_setup_" +
          this.tydata.split("|")[0] +
          ".exe";
      }
    },
  },
  created() {
    jsonp("https://db.wenhua.com.cn/inc/update.asp", {
      appid: 12,
      t: 1,
    },60000)
      .then((data) => {
        this.tydata = data;

        this.tybanben =
          " 版本:" +
          this.tydata.split("|")[0] +
          "" +
          " (第" +
          this.tydata.split("|")[3] +
          "次修改) " +
          "\xa0\xa0" +
          " 大小:" +
          this.tydata.split("|")[2] +
          " \xa0\xa0" +
          "日期:" +
          this.tydata.split("|")[1];
      })
      .catch((err) => {
        console.log(err);
      });
  },
};
</script>

<style>
.tongyongdl {
  width: 1004px;
  background: url("../../../../assets/images/1.png") no-repeat top;
  background-size: 1004px auto;
  min-height: 200px;
}
.tongyongcard {
  width: 980px;
  margin: 0 auto;
  height: 180px;

  text-align: center;
  padding-top: 30px;
}
.tongyongbody {
  width: 1004px;
  min-height: 633px;
}
.tongyongbodydl {
  width: 1004px;
  min-height: 190px;
}
.tongyongdllf {
  width: 450px;
  float: left;
  height: 190px;
  margin-left: 20px;
}
.h4p {
  height: 28px;
  line-height: 28px;
  color: #727983;
}

.pingjia {
  width: 1004px;
  background: url("../../../../assets/images/2.png") no-repeat top;
  background-size: 1004px auto;
  min-height: 600px;
  margin-bottom: 3px;
}
.yongpingjia {
  margin-top: 50px;
  letter-spacing: 1px;
  background: url("../../../../assets/images/pj.png") no-repeat left;
  margin-left: -9px;
  color: white;
  height: 40px;
  width: 110px;
  text-align: center;
  line-height: 30px;
}

.pagebt {
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  background: #ffffff;
  color: #a6a6a6;
  float: right;
  margin-left: 5px;
  margin-right: 5px;
  user-select: none;
  border: 1px solid #dfdfdf;
}
.clickpagebt {
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  background: #044c7e;
  color: #ffffff;
  margin-left: 5px;
  margin-right: 5px;
  float: right;
  user-select: none;
  border: 1px solid #dfdfdf;
}
.notclick {
  height: 25px;
  width: 25px;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  background: #ffffff;
  color: #a6a6a6;
  float: right;
  margin-left: 5px;
  margin-right: 5px;
  pointer-events: none;
  user-select: none;
  border: 1px solid #dfdfdf;
}
.star {
  margin-left: 5px;
  position: relative;
  top: 3px;
}
.starpj {
  height: 60px;
  line-height: 60px;
  color: #575759;
  font-size: 16px;
  margin-left: 40px;
  font-weight: bold;
  letter-spacing: 1px;
}
.waflls{
  line-height: 20px;
  padding: 5px 0;
  color: #727983;
  font-size: 15px;
}
</style>